import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.auth,
      account: state => !helpers.isEmpty(state.auth) && !helpers.isEmpty(state.auth.active_pt) ? state.auth.active_pt : null,
    })
  },

  data() {
    return {
      left_menus: [
        { value: 'panel', name: 'Beranda', data_tab: 'dashboard', icon: 'fas fa-home' },
        { value: 'panel/classes', name: 'Kelas Akademik', data_tab: 'classes', icon: 'fas fa-graduation-cap', roles: ['ADMIN', 'LECTURER', 'STUDENT'] },
        { value: 'panel/classes?tab=1', name: 'Kelas Umum', data_tab: 'group-discussion', icon: 'fas fa-users' },
        { value: 'panel/messages', name: 'Pesan', data_tab: 'message', icon: 'fas fa-comments' },
        {
          value: '',
          name: 'Perguruan Tinggi',
          data_tab: 'learning',
          icon: 'fas fa-university',
          roles: ['ADMIN'],
          submenus: [
            { value: 'panel/admin/classes', name: 'Data Kelas', data_tab: 'data-classes', icon: 'fas fa-chalkboard' },
            { value: 'panel/admin/accounts', name: 'Data Pengguna', data_tab: 'data-accounts', icon: 'fas fa-users', line: true },
            { value: 'panel/admin/news', name: 'Berita Kampus', data_tab: 'university-news', icon: 'fas fa-newspaper-o', line: true },
            { value: 'panel/admin/settings', name: 'Pengaturan', data_tab: 'settings', icon: 'fas fa-cogs' }
          ]
        },
        { value: 'panel/news', name: 'Berita', icon: 'fas fa-newspaper-o', whitelist_email: ['edlink.sevima@gmail.com'] },
        { value: 'panel/accounts', name: 'Akun Siakad', icon: 'fas fa-users', whitelist_email: ['edlink.sevima@gmail.com'] },
        { value: 'panel/users', name: 'Pengguna', icon: 'fas fa-users', whitelist_email: ['edlink.sevima@gmail.com'] },
        {
          value: '',
          name: 'Laporan',
          icon: 'fas fa-area-chart',
          whitelist_email: ['edlink.sevima@gmail.com'],
          submenus: [
            { value: 'panel/reports', name: 'Perguruan Tinggi', icon: 'fas fa-university' },
            { value: 'panel/reports/posts', name: 'Postingan', icon: 'fas fa-stream' },
            { value: 'panel/reports/stats', name: 'Statistik', icon: 'far fa-area-chart' },
          ]
        },
      ],
      right_menus: [
        // { value: 'panel/ebook/discover', name: 'E-Book', data_tab: 'explore', icon: 'fas fa-book', tag: 'warning', tag_text: 'Gratis' },
        { value: 'panel/groups/explore', name: 'Jelajahi', data_tab: 'explore', icon: 'fas fa-globe' },
        {
          value: '',
          name: 'Sistem',
          icon: 'fas fa-cogs',
          whitelist_email: ['edlink.sevima@gmail.com'],
          submenus: [
            { value: 'panel/system/packages', name: 'Paket', icon: 'fas fa-box' },
            { value: 'panel/system/queues', name: 'Queue', icon: 'fas fa-university' },
          ]
        },
      ],
      account_menus: [
        { value: 'panel/profile', name: 'Profil', data_tab: 'profil', icon: 'fas fa-user'},
        { value: 'panel/university', name: 'Sambungkan Akun', data_tab: 'account', icon: 'fas fa-user' },
        { value: 'panel/media', name: 'Media Library', data_tab: 'gallery', icon: 'fas fa-photos' },
      ],
    }
  },

  methods: {
    isCanSeeMenu(menu) {
      const account = this.account;
      let is_can = false;

      if (!this.isEmpty(this.user) && !this.isEmpty(menu.whitelist_email) && menu.whitelist_email.indexOf(this.user.email) > -1) {
        is_can = true;
      } else if (!this.isEmpty(account) && !this.isEmpty(menu.roles) && menu.roles.indexOf(account.type) > -1) {
        is_can = true;
      } else if (!this.isEmpty(menu.roles) && !this.isEmpty(menu.whitelist_email)) {
        is_can = true;
      } else if (this.isEmpty(menu.roles) && this.isEmpty(menu.whitelist_email)) {
        is_can = true
      }

      return is_can;
    },
  }
}